import { DeviceType } from "src/services/ContentsService";
import { CurrencyIsoCode } from "@/enums";

export enum Platform {
  Steam = "steam",
  Quest = "quest",
}

export enum PaymentMethod {
  Paypal = "Paypal",
  Inicis = "Inicis",
}

// 통화 enum 은 `@/enums` 가 단일 출처다. 과거 여기 같은 이름으로 중복 정의(USD/KRW/JPY)돼 있었고,
// 값이 같아 우연히 호환됐다. `@/enums` 에 EUR/GBP 가 추가되며 두 타입이 갈라져 전 호출처에서
// 타입 에러가 났다 → **재노출로 통합**(호출처 import 경로는 그대로 두어 변경 0).
//
// ⚠️ 타입상 게임 가격도 EUR/GBP 를 가질 수 있게 넓어지지만, **실제 게임 카탈로그는 USD/KRW/JPY 만
// 보유**한다. EU/GB 에서 게임 가격 조회는 런타임에 미스가 나며, GE cart-info 가 통화 불일치를
// 감지해 라인을 드롭한다(과다청구 방지). 근본 해소는 게임 카탈로그에 EUR/GBP 등록이 필요하다.
export { CurrencyIsoCode };

export enum KeyStatus {
  Pending = "Pending",
  Locked = "Locked",
  Completed = "Completed",
  Disabled = "Disabled",
}

export interface PriceDiscount {
  currency: CurrencyIsoCode;
  price: number;
  discount: number;
  discountPercentile: number;
}

export interface PlatformPriceList {
  gameLink: string;
  platform: Platform;
  priceList: PriceDiscount[];
}

export interface GameResell {
  id: string;
  featured?: number;
  contentId: string;
  extraField: Record<string, any>;
  name: string;
  category: string;
  subCategory: string;
  compatibleDevices: DeviceType[];
  thumbnailImageLink: string;
  imageLinks: string[];
  platformList: PlatformPriceList[];
  enable: boolean;
  description: string;
  desktopBgImageLink: string;
  mobileBgImageLink: string;
  thumbnailPortraitImageLink: string;
  disableCountryList: string[];
}

export interface GameResellKey {
  id: string;
  platform: Platform;
  gameResellId: string;
  key: string;
  uid: string;
  issuedEmail: string;
  status: KeyStatus;
  createdDate: number;
  issuedDate: number;
  lockTime: number;
  version: number;
}

export interface GameResellOrder {
  id: string;
  status: KeyStatus;
  note: string;
  invoiceNumber: string;
  email: string;
  orderEmail: string;
  paymentMethod: PaymentMethod;
  paymentDetail: string;
  gameResellId: string;
  gameResellCouponId: string;
  gameResellKeyId: string;
  gameResellKey: GameResellKey;
  price: PriceDiscount;
  discountPercentile: number;
  purchaseTime: number;
  createTime: number;
}

export interface GameResellKeyCount {
  platform: string;
  locked: number;
  pending: number;
}
